export enum language {
  en = 'en',
  ru = 'ru',
  zh = 'zh'
}
